// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ThemeManager } from '@front/controls/misc/ThemeManager';
import { DataCacheToolType } from '../DataCacheToolEnums';
import { DataCacheTool } from '../DataCacheTool';
import { DynProperty } from '../../DynProperty';
export class SymbolDataCacheTool extends DataCacheTool {
    /**
     * Constructor for SymbolDataCacheTool
     */
    constructor() {
        super();
        this.symbolNum = -1;
        this.symbolBmp = null;
        this.ToolType = DataCacheToolType.Symbol;
        this.InitPoints(1);
        this.InitBlock();
    }
    /**
     * Gets the symbol number
     * @returns {number} - Symbol number
     */
    get SymbolNum() {
        return this.symbolNum;
    }
    /**
     * Sets the symbol number
     * @param {number} value - Symbol number to set
     */
    set SymbolNum(value) {
        if (this.symbolNum === value)
            return;
        this.symbolNum = value;
        const key = 'symbol' + (this.symbolNum + 1) + 'Img'; // Adjust the key generation accordingly
        this.symbolBmp = ThemeManager.colors[key];
    }
    /**
     * Gets the symbol bitmap
     * @returns {any} - Symbol bitmap (adjust the type accordingly)
     */
    get SymbolBmp() {
        return this.symbolBmp;
    }
    /**
     * Initializes the block for the tool
     */
    InitBlock() {
        super.InitBlock();
        this.Width = 4;
        this.SymbolNum = 0;
    }
    /**
     * Gets the maximum points count required for the tool
     * @returns {number} - Maximum points count
     */
    MaxPointsCount() {
        return 1;
    }
    /**
     * Gets the minimum points count required for the tool
     * @returns {number} - Minimum points count
     */
    MinPointsCount() {
        return 1;
    }
    /**
     * Get properties for the tool
     * @returns {DynProperty[]} - Array of dynamic properties
     */
    Properties() {
        const oldPros = super.Properties();
        const props = [];
        props.push(new DynProperty('Symbol', this.symbolNum, DynProperty.SYMBOL, DynProperty.VISUAL_GROUP));
        const len = oldPros.length;
        for (let i = 0; i < len; i++) {
            const prop = oldPros[i];
            if (prop.group === DynProperty.NUMERICAL_PARAMETRS_GROUP ||
                prop.group === DynProperty.HIDDEN_GROUP ||
                prop.name === 'Stick to period' ||
                prop.name === 'IsBackground') {
                props.push(prop);
            }
        }
        return props;
    }
    /**
     * Callback function for handling property changes
     * @param {DynProperty[]} properties - Array of dynamic properties
     */
    callBack(properties) {
        super.callBack(properties);
        const prop = DynProperty.getPropertyByName(properties, 'Symbol');
        if (prop)
            this.SymbolNum = prop.value;
    }
}
